import { useEffect } from 'react';
import useApi from './useApi';
import { PbiAuthorization } from '../types/PbiTypes';
import useApiEndpoints from '../context/useApiEndpoints';
import { useAuthStore } from '../context/AuthContext';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { setPbiAuthorization } = useAuthStore();
    const { state, getApiData } = useApi();

    const getPbiAccessToken = () =>
        getApiData({
            endpoint: apiEndpoints['getPowerBiEmbeddedToken'].url,
        });

    useEffect(() => {
        if (state.status === 'success') {
            const pbiAuthorization = state.result as PbiAuthorization;
            setPbiAuthorization({ ...pbiAuthorization });
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { getPbiAccessToken };
};
